import ShowAllSelectionsButton from './_show-all-selections-button.js'
import MarketLayoutDescriptors from './_market-layout-descriptors.js'
import FlexPane from './_flex-pane.js'
import Market from './_market.js'
import PlayerInfo from './_player-info.js'
import SelectionHeaders from './_selection-headers.js'

export default {
  name: 'PlayerPropMarketContent',
  values: {
    showAllSelectionsButton: {
      configSet: ShowAllSelectionsButton,
      configValues: {},
    },
    rowsThreshold: 10,
    numberOfExpandedRows: 8,
    layoutDescriptors: {
      configSet: MarketLayoutDescriptors,
      configValues: {},
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '8px',
        },
      },
    },
    innerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    marketsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          justifyContent: 'flex-end',
          flexBasis: '70%',
          minWidth: 0,
        },
      },
    },
    market: {
      configSet: Market,
      configValues: {
        selectionButton: {
          view: {
            nameDisplay: 'hide',
            _mobile_nameDisplay: 'hide',
            layoutDirection: 'horizontalAlignCenter',
            _mobile_layoutDirection: 'vertical',
            infoTextHandicapBase: {
              truncate: true,
              container: {
                flexShrink: 1,
              },
            },
          },
        },
      },
    },
    playersInfoListContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          flexGrow: 1,
          flexBasis: '208px',
          _mobile_flexBasis: '128px',
          minWidth: '208px',
          _mobile_minWidth: '128px',
          padding: '17px 0 0 0',
        },
      },
    },
    playerInfo: {
      configSet: PlayerInfo,
      configValues: {},
    },
    selectionHeaders: {
      configSet: SelectionHeaders,
      configValues: {
        container: {
          itemSpacing: '4px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
